export const ERRORS = {
  INVALID_PARAMS: 'INVALID_PARAMS',
  INVALID_SYNTAX: 'INVALID_SYNTAX',
  INVALID_OPERATION: 'INVALID_OPERATION',
  OPERATION_FAIL: 'OPERATION_FAIL',
  NETWORK_ERROR: 'NETWORK_ERROR',
  UNKOWN_ERROR: 'UNKOWN_ERROR',
}
